webpackJsonp([114276838955818,60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"excerpt":"Check out  MailChimp's pattern library about page  for inspiration.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/about.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"About the design system","description":"The about page should provide a bit more high-level information about the system, who's behind it, its back story, and any other info that's helpful to lay out.","status":null,"path":"/about","group":null,"subgroup":null,"layout":"page"}}},{"node":{"excerpt":"For inspiration, check out  Salesforce's Lightning Design System accessibility guidelines , and be sure to check out the fantastic  a11yproject  for an accessibility checklist, patterns, and resources.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/accessibility.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Accessibility","description":"Describe the design system's approach to accessibility","status":"Complete","path":"/guidelines/accessibility","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/messaging/alert.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Alert","description":"Alert description","status":"Complete","path":"/components/messaging/alert","group":"components","subgroup":"messaging","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/charts-and-graphs/bar-graph.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Bar graph","description":"Bar graph description","status":"Complete","path":"/components/charts-and-graphs/bar-graph","group":"components","subgroup":"charts-and-graphs","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/blocks-and-cards/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Blocks and Cards","description":"A block component that consists of a header, body, and footer.","status":null,"path":"/components/blocks-and-cards","group":"components","subgroup":"blocks-and-cards","layout":"component-category"}}},{"node":{"excerpt":"There is a difference between  support and optimization . These guidelines explain which browser environments the design system is optimized for, typically in the form of  graded browser support .","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/browser-support.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Browser support","description":"Guidelines that explain which browsers the design system is optimized for","status":"Complete","path":"/guidelines/browsers","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/buttons/button.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Button","description":"Buttons are simple controls for executing specific on-page actions and code. Buttons are most commonly used in forms, dialogs, and modals to facilitate required user actions.","status":"Complete","path":"/components/buttons/button","group":"components","subgroup":"buttons","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/buttons/button-group.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Button group","description":"Button group description","status":"Not Started","path":"/components/buttons/button-group","group":"components","subgroup":"buttons","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/buttons/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Buttons","description":"Button styles and interactions for every context","status":null,"path":"/components/buttons","group":"components","subgroup":"buttons","layout":"component-category"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/blocks-and-cards/card.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Card","description":"This is a card","status":"Complete","path":"/components/blocks-and-cards/card","group":"components","subgroup":"blocks-and-cards","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/lists-and-collections/card-list.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Card list","description":"Card description","status":"Not Started","path":"/components/lists-and-collections/card-list","group":"components","subgroup":"lists-and-collections","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/charts-and-graphs/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Charts and graphs","description":"Essential data-viz patterns","status":null,"path":"/components/charts-and-graphs","group":"components","subgroup":"charts-and-graphs","layout":"component-category"}}},{"node":{"excerpt":"Check out the  Frontend Guidelines Questionnaire  and  CSS Architecture for Design Systems  for inspiration.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/code.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Code conventions","description":"Guidelines for the design system's code base.","status":"Complete","path":"/guidelines/code","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"For inspiration, check out  Material Design's color styles page .","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/color.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Color Palette","description":null,"status":"Complete","path":"/styles/color","group":"styles","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Components","description":"Component overview description","status":"Complete","path":"/components","group":"components","subgroup":null,"layout":"component-index"}}},{"node":{"excerpt":"People Describe who's involved in changes to the system. Describe who's expected to do the work and who approves changes. Process Describe specifically the process or processes by which the system gets  updated . What happens when existing component…","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/contribute.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Contributing to the design system","description":"This page explains the process (or processes) by which the design system gets updated","status":null,"path":"/contribute","group":null,"subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Form guidelines go here","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/data-entry.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Data entry","description":"High-level form guidelines","status":"Complete","path":"/guidelines/data-entry","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Guidelines go here","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/data-validation.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Data validation","description":"Guidelines around validating data","status":"Complete","path":"/guidelines/data-validation","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Here is where you take the time to explain the principles that are encapsulated in the entire design system. These principles will manifest themselves in different ways, from high-level guidelines to low-level components. For inspiration, be sure to…","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/principles.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Design principles","description":"The design system's guiding values","status":"Complete","path":"/guidelines/principles","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Here's the place you can define your design system's design tokens. For inspiration, be sure to check out  Salesforce's Lightning Design System design tokens .","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/design-tokens.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Design tokens","description":"Design token information","status":"Complete","path":"/styles/design-tokens","group":"styles","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Provide links and information for downloading the design system's files:","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/downloads.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Downloads","description":"The downloads page features links to downloads","status":null,"path":"/downloads","group":null,"subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/headers-and-footers/footer.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Footer","description":"Logo and housekeeping links displayed at page bottom","status":"Not Started","path":"/components/headers-and-footers/footer","group":"components","subgroup":"headers-and-footers","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/form-controls/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Form controls","description":"Components for efficient data entry","status":null,"path":"/components/form-controls","group":"components","subgroup":"form-controls","layout":"component-category"}}},{"node":{"excerpt":"Downloading Provide links and information for downloading the design system's files: File Structure Provide an overview of the file system structure and how users of the design system should integrate the design system's code into their project. This…","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/getting-started.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Getting Started","description":"The getting started page should provide information for how to get up and running with the design system.","status":null,"path":"/getting-started","group":null,"subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Guidelines is where you'll find UX guidance for specific aspects of app/site design (navigation models, data entry, form validation, accessibility, and so on). These will give high-level tours of the relevant components and styles, with links to the…","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Guidelines","description":"This is the guidelines overview description. It will elaborate on the guidelines and principles that need to be followed to build applications.","status":null,"path":"/guidelines","group":"guidelines","subgroup":null,"layout":"landing"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/headers-and-footers/header.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Header","description":"Header description","status":"Not Started","path":"/components/headers-and-footers/header","group":"components","subgroup":"headers-and-footers","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/headers-and-footers/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Headers and footers","description":"Responsive containers for app title, navigation, and search","status":null,"path":"/components/headers-and-footers","group":"components","subgroup":"headers-and-footers","layout":"component-category"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/blocks-and-cards/hero.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Hero","description":"This is a hero.","status":"Not Started","path":"/components/blocks-and-cards/hero","group":"components","subgroup":"blocks-and-cards","layout":"component-detail"}}},{"node":{"excerpt":"Icons are a unique beast, so it's important to define how to use and create icons for the design system.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/iconography.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Iconography","description":"How to style or construct icons for the design system","status":"Complete","path":"/styles/iconography","group":"styles","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/icons/icons.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Icons","description":"Icons description","status":"Not Started","path":"/components/icons/icons","group":"components","subgroup":"icons","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/icons/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Icons","description":"Icon reference and usage","status":null,"path":"/components/icons","group":"components","subgroup":"icons","layout":"component-category"}}},{"node":{"excerpt":"Image style guidelines go here","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/imagery.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Imagery","description":"Styles for treating pictures and graphics","status":"Complete","path":"/styles/imagery","group":"styles","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Guidelines go here","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/input-modes.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Input modes","description":"Guidelines around multiple types of input","status":"Complete","path":"/guidelines/input-modes","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/interactive/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Interactive","description":"Components for revealing/hiding content for more compressed and focused layouts","status":null,"path":"/components/interactive","group":"components","subgroup":"interactive","layout":"component-category"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/lists-and-collections/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Lists and collections","description":"From simple text lists to complex card collections","status":null,"path":"/components/lists-and-collections","group":"components","subgroup":"lists-and-collections","layout":"component-category"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/media/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Media","description":"Images and video","status":null,"path":"/components/media","group":"components","subgroup":"media","layout":"component-category"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/messaging/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Messaging","description":"Tools for status and info updates, from micro-copy tooltips to high-impact alerts","status":null,"path":"/components/messaging","group":"components","subgroup":"messaging","layout":"component-category"}}},{"node":{"excerpt":"For inspiration, check out  Material Design's thorough motion guidelines , as well as all of  Val Head 's fantastic resources around UI animation.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/motion.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Motion","description":"How the style guide uses motion to enhance the user experience.","status":"Complete","path":"/styles/motion","group":"styles","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Guidelines go here","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/navigation.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Navigation","description":"Guidelines for getting around a UI","status":"Complete","path":"/guidelines/navigation","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/navigation/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Navigation","description":"Components for wayfinding (see also [headers and footers](../headers-and-footers/index.html))","status":null,"path":"/components/navigation","group":"components","subgroup":"navigation","layout":"component-category"}}},{"node":{"excerpt":"Guidelines go here","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/notifications.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Notifications","description":"Guidelines around how and when to respectfully interrupt users","status":"Complete","path":"/guidelines/notifications","group":"guidelines","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/page-templates.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Page Templates","description":"This section collects commonly-used page templates that are useful as a starting point for similar use cases.","status":null,"path":"/page-templates","group":"page-templates","subgroup":null,"layout":"page-templates-index"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/text/page-header.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Page header","description":"Page header description","status":"Not Started","path":"/components/text/page-header","group":"components","subgroup":"text","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/navigation/pagination.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Pagination","description":"Pagination description","status":"Complete","path":"/components/navigation/pagination","group":"components","subgroup":"navigation","layout":"component-detail"}}},{"node":{"excerpt":"Release notes go here","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/history.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Release history","description":null,"status":null,"path":"/history","group":null,"subgroup":null,"layout":"page"}}},{"node":{"excerpt":"A clear roadmap instills confidence that the system is alive and is actively being worked on. Provide information about what's to come. This ties into the  release history  section.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/roadmap.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Roadmap","description":"The roadmap shows the plan of attack for upcoming releases to the design system","status":null,"path":"/roadmap","group":null,"subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/text/section-header.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Section header","description":"Section header description","status":"Not Started","path":"/components/text/section-header","group":"components","subgroup":"text","layout":"component-detail"}}},{"node":{"excerpt":"The homepage of a style guide should provide high-level information around what the design system is, what benefits it provides, who it's for, and how to get started with it. Like any good index page, it should provide clear navigation to key parts…","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Style Guide Guides","description":"A boilerplate for creating superb style guides","status":null,"path":"/","group":null,"subgroup":null,"layout":"index"}}},{"node":{"excerpt":"Styles are guidelines for core brand attributes, organized by category. These are descriptions of conventions that cut across component and suggest the rules that go into building/designing components and their treatment. Like the  Guidelines , each…","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Styles","description":"The attributes of the brand","status":null,"path":"/styles","group":"styles","subgroup":null,"layout":"landing"}}},{"node":{"excerpt":"Support opportunities Pair sessions Workshops Webinars Consulting sessions Tutorials Employee onboarding Office hours Chat tools Issue trackers Forums Take the time to present all support and training information; it helps give users confidence you…","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/support.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Support","description":"The support page provides information about getting help with using the design system","status":null,"path":"/support","group":null,"subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/tables/table.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Table","description":"Table description","status":"Complete","path":"/components/tables/table","group":"components","subgroup":"tables","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/tables/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Tables","description":"Responsive data display for a range of contexts","status":null,"path":"/components/tables","group":"components","subgroup":"tables","layout":"component-category"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/interactive/tabs.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Tabs","description":"Tabs provide a compact way to display and navigate modular, segmented content containers.","status":"Complete","path":"/components/interactive/tabs","group":"components","subgroup":"interactive","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/text/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Text","description":"Text components description","status":null,"path":"/components/text","group":"components","subgroup":"text","layout":"component-category"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/buttons/text-button.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Text button","description":"Text button description","status":"Not Started","path":"/components/buttons/text-button","group":"components","subgroup":"buttons","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/form-controls/text-field.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Text field","description":"Text field description","status":"In Progress","path":"/components/form-controls/text-field","group":"components","subgroup":"form-controls","layout":"component-detail"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/text/text-passage.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Text passage","description":"Text passage description","status":"Not Started","path":"/components/text/text-passage","group":"components","subgroup":"text","layout":"component-detail"}}},{"node":{"excerpt":"For inspiration, check out  Material Design's typography styles","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/typography.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Typography","description":"Typography style description","status":"Complete","path":"/styles/typography","group":"styles","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/utilities/index.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Utilities","description":"Utilities are CSS helper classes that apply a single rule to an element. They should be used to accomplish specific styling needs, and should be used sparingly, especially when modifying the default styling of a Style Guide Guide component.","status":null,"path":"/utilities","group":"utilities","subgroup":null,"layout":"utilities-index"}}},{"node":{"excerpt":"","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/components/media/video.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Video","description":"Video description","status":"Complete","path":"/components/media/video","group":"components","subgroup":"media","layout":"component-detail"}}},{"node":{"excerpt":"For inspiration, check out MailChimp's fantastic  Voice and Tone  website.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/styles/voice-and-tone.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Voice and tone","description":"Capturing the personality and authority of the brand in words","status":"Complete","path":"/styles/voice-and-tone","group":"styles","subgroup":null,"layout":"page"}}},{"node":{"excerpt":"Guidelines go here.","id":"/Users/ian/Sites/gatsby-style-guide-guide/content/guidelines/writing.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Writing Guidelines","description":"Guidelines for writing best practices","status":"Complete","path":"/guidelines/writing","group":"guidelines","subgroup":null,"layout":"page"}}}]}},"layoutContext":{}}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/ian/Sites/gatsby-style-guide-guide/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__("./src/layouts/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json");
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/prismjs/prism.js":
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/* **********************************************
	     Begin prism-core.js
	********************************************** */
	
	var _self = (typeof window !== 'undefined')
		? window   // if in browser
		: (
			(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
		);
	
	/**
	 * Prism: Lightweight, robust, elegant syntax highlighting
	 * MIT license http://www.opensource.org/licenses/mit-license.php/
	 * @author Lea Verou http://lea.verou.me
	 */
	
	var Prism = (function(){
	
	// Private helper vars
	var lang = /\blang(?:uage)?-([\w-]+)\b/i;
	var uniqueId = 0;
	
	var _ = _self.Prism = {
		manual: _self.Prism && _self.Prism.manual,
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
		util: {
			encode: function (tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
				} else if (_.util.type(tokens) === 'Array') {
					return tokens.map(_.util.encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},
	
			type: function (o) {
				return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
			},
	
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},
	
			// Deep clone a language definition (e.g. to extend it)
			clone: function (o, visited) {
				var type = _.util.type(o);
				visited = visited || {};
	
				switch (type) {
					case 'Object':
						if (visited[_.util.objId(o)]) {
							return visited[_.util.objId(o)];
						}
						var clone = {};
						visited[_.util.objId(o)] = clone;
	
						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = _.util.clone(o[key], visited);
							}
						}
	
						return clone;
	
					case 'Array':
						if (visited[_.util.objId(o)]) {
							return visited[_.util.objId(o)];
						}
						var clone = [];
						visited[_.util.objId(o)] = clone;
	
						o.forEach(function (v, i) {
							clone[i] = _.util.clone(v, visited);
						});
	
						return clone;
				}
	
				return o;
			}
		},
	
		languages: {
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);
	
				for (var key in redef) {
					lang[key] = redef[key];
				}
	
				return lang;
			},
	
			/**
			 * Insert a token before another token in a language literal
			 * As this needs to recreate the object (we cannot actually insert before keys in object literals),
			 * we cannot just provide an object, we need anobject and a key.
			 * @param inside The key (or language id) of the parent
			 * @param before The key to insert before. If not provided, the function appends instead.
			 * @param insert Object with the key/value pairs to insert
			 * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || _.languages;
				var grammar = root[inside];
	
				if (arguments.length == 2) {
					insert = arguments[1];
	
					for (var newToken in insert) {
						if (insert.hasOwnProperty(newToken)) {
							grammar[newToken] = insert[newToken];
						}
					}
	
					return grammar;
				}
	
				var ret = {};
	
				for (var token in grammar) {
	
					if (grammar.hasOwnProperty(token)) {
	
						if (token == before) {
	
							for (var newToken in insert) {
	
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}
	
						ret[token] = grammar[token];
					}
				}
	
				// Update references in other language definitions
				_.languages.DFS(_.languages, function(key, value) {
					if (value === root[inside] && key != inside) {
						this[key] = ret;
					}
				});
	
				return root[inside] = ret;
			},
	
			// Traverse a language definition with Depth First Search
			DFS: function(o, callback, type, visited) {
				visited = visited || {};
				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);
	
						if (_.util.type(o[i]) === 'Object' && !visited[_.util.objId(o[i])]) {
							visited[_.util.objId(o[i])] = true;
							_.languages.DFS(o[i], callback, null, visited);
						}
						else if (_.util.type(o[i]) === 'Array' && !visited[_.util.objId(o[i])]) {
							visited[_.util.objId(o[i])] = true;
							_.languages.DFS(o[i], callback, i, visited);
						}
					}
				}
			}
		},
		plugins: {},
	
		highlightAll: function(async, callback) {
			_.highlightAllUnder(document, async, callback);
		},
	
		highlightAllUnder: function(container, async, callback) {
			var env = {
				callback: callback,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};
	
			_.hooks.run("before-highlightall", env);
	
			var elements = env.elements || container.querySelectorAll(env.selector);
	
			for (var i=0, element; element = elements[i++];) {
				_.highlightElement(element, async === true, env.callback);
			}
		},
	
		highlightElement: function(element, async, callback) {
			// Find language
			var language, grammar, parent = element;
	
			while (parent && !lang.test(parent.className)) {
				parent = parent.parentNode;
			}
	
			if (parent) {
				language = (parent.className.match(lang) || [,''])[1].toLowerCase();
				grammar = _.languages[language];
			}
	
			// Set language on the element, if not present
			element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
	
			if (element.parentNode) {
				// Set language on the parent, for styling
				parent = element.parentNode;
	
				if (/pre/i.test(parent.nodeName)) {
					parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
				}
			}
	
			var code = element.textContent;
	
			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};
	
			_.hooks.run('before-sanity-check', env);
	
			if (!env.code || !env.grammar) {
				if (env.code) {
					_.hooks.run('before-highlight', env);
					env.element.textContent = env.code;
					_.hooks.run('after-highlight', env);
				}
				_.hooks.run('complete', env);
				return;
			}
	
			_.hooks.run('before-highlight', env);
	
			if (async && _self.Worker) {
				var worker = new Worker(_.filename);
	
				worker.onmessage = function(evt) {
					env.highlightedCode = evt.data;
	
					_.hooks.run('before-insert', env);
	
					env.element.innerHTML = env.highlightedCode;
	
					callback && callback.call(env.element);
					_.hooks.run('after-highlight', env);
					_.hooks.run('complete', env);
				};
	
				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			}
			else {
				env.highlightedCode = _.highlight(env.code, env.grammar, env.language);
	
				_.hooks.run('before-insert', env);
	
				env.element.innerHTML = env.highlightedCode;
	
				callback && callback.call(element);
	
				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
			}
		},
	
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},
	
		matchGrammar: function (text, strarr, grammar, index, startPos, oneshot, target) {
			var Token = _.Token;
	
			for (var token in grammar) {
				if(!grammar.hasOwnProperty(token) || !grammar[token]) {
					continue;
				}
	
				if (token == target) {
					return;
				}
	
				var patterns = grammar[token];
				patterns = (_.util.type(patterns) === "Array") ? patterns : [patterns];
	
				for (var j = 0; j < patterns.length; ++j) {
					var pattern = patterns[j],
						inside = pattern.inside,
						lookbehind = !!pattern.lookbehind,
						greedy = !!pattern.greedy,
						lookbehindLength = 0,
						alias = pattern.alias;
	
					if (greedy && !pattern.pattern.global) {
						// Without the global flag, lastIndex won't work
						var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
						pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
					}
	
					pattern = pattern.pattern || pattern;
	
					// Don’t cache length as it changes during the loop
					for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {
	
						var str = strarr[i];
	
						if (strarr.length > text.length) {
							// Something went terribly wrong, ABORT, ABORT!
							return;
						}
	
						if (str instanceof Token) {
							continue;
						}
	
						if (greedy && i != strarr.length - 1) {
							pattern.lastIndex = pos;
							var match = pattern.exec(text);
							if (!match) {
								break;
							}
	
							var from = match.index + (lookbehind ? match[1].length : 0),
							    to = match.index + match[0].length,
							    k = i,
							    p = pos;
	
							for (var len = strarr.length; k < len && (p < to || (!strarr[k].type && !strarr[k - 1].greedy)); ++k) {
								p += strarr[k].length;
								// Move the index i to the element in strarr that is closest to from
								if (from >= p) {
									++i;
									pos = p;
								}
							}
	
							// If strarr[i] is a Token, then the match starts inside another Token, which is invalid
							if (strarr[i] instanceof Token) {
								continue;
							}
	
							// Number of tokens to delete and replace with the new match
							delNum = k - i;
							str = text.slice(pos, p);
							match.index -= pos;
						} else {
							pattern.lastIndex = 0;
	
							var match = pattern.exec(str),
								delNum = 1;
						}
	
						if (!match) {
							if (oneshot) {
								break;
							}
	
							continue;
						}
	
						if(lookbehind) {
							lookbehindLength = match[1] ? match[1].length : 0;
						}
	
						var from = match.index + lookbehindLength,
						    match = match[0].slice(lookbehindLength),
						    to = from + match.length,
						    before = str.slice(0, from),
						    after = str.slice(to);
	
						var args = [i, delNum];
	
						if (before) {
							++i;
							pos += before.length;
							args.push(before);
						}
	
						var wrapped = new Token(token, inside? _.tokenize(match, inside) : match, alias, match, greedy);
	
						args.push(wrapped);
	
						if (after) {
							args.push(after);
						}
	
						Array.prototype.splice.apply(strarr, args);
	
						if (delNum != 1)
							_.matchGrammar(text, strarr, grammar, i, pos, true, token);
	
						if (oneshot)
							break;
					}
				}
			}
		},
	
		tokenize: function(text, grammar, language) {
			var strarr = [text];
	
			var rest = grammar.rest;
	
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}
	
				delete grammar.rest;
			}
	
			_.matchGrammar(text, strarr, grammar, 0, 0, false);
	
			return strarr;
		},
	
		hooks: {
			all: {},
	
			add: function (name, callback) {
				var hooks = _.hooks.all;
	
				hooks[name] = hooks[name] || [];
	
				hooks[name].push(callback);
			},
	
			run: function (name, env) {
				var callbacks = _.hooks.all[name];
	
				if (!callbacks || !callbacks.length) {
					return;
				}
	
				for (var i=0, callback; callback = callbacks[i++];) {
					callback(env);
				}
			}
		}
	};
	
	var Token = _.Token = function(type, content, alias, matchedStr, greedy) {
		this.type = type;
		this.content = content;
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || "").length|0;
		this.greedy = !!greedy;
	};
	
	Token.stringify = function(o, language, parent) {
		if (typeof o == 'string') {
			return o;
		}
	
		if (_.util.type(o) === 'Array') {
			return o.map(function(element) {
				return Token.stringify(element, language, o);
			}).join('');
		}
	
		var env = {
			type: o.type,
			content: Token.stringify(o.content, language, parent),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language,
			parent: parent
		};
	
		if (o.alias) {
			var aliases = _.util.type(o.alias) === 'Array' ? o.alias : [o.alias];
			Array.prototype.push.apply(env.classes, aliases);
		}
	
		_.hooks.run('wrap', env);
	
		var attributes = Object.keys(env.attributes).map(function(name) {
			return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}).join(' ');
	
		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
	
	};
	
	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _self.Prism;
		}
	
		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data),
					lang = message.language,
					code = message.code,
					immediateClose = message.immediateClose;
	
				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}
	
		return _self.Prism;
	}
	
	//Get current script and highlight
	var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();
	
	if (script) {
		_.filename = script.src;
	
		if (!_.manual && !script.hasAttribute('data-manual')) {
			if(document.readyState !== "loading") {
				if (window.requestAnimationFrame) {
					window.requestAnimationFrame(_.highlightAll);
				} else {
					window.setTimeout(_.highlightAll, 16);
				}
			}
			else {
				document.addEventListener('DOMContentLoaded', _.highlightAll);
			}
		}
	}
	
	return _self.Prism;
	
	})();
	
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Prism;
	}
	
	// hack for components to work correctly in node.js
	if (typeof global !== 'undefined') {
		global.Prism = Prism;
	}
	
	
	/* **********************************************
	     Begin prism-markup.js
	********************************************** */
	
	Prism.languages.markup = {
		'comment': /<!--[\s\S]*?-->/,
		'prolog': /<\?[\s\S]+?\?>/,
		'doctype': /<!DOCTYPE[\s\S]+?>/i,
		'cdata': /<!\[CDATA\[[\s\S]*?]]>/i,
		'tag': {
			pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
			greedy: true,
			inside: {
				'tag': {
					pattern: /^<\/?[^\s>\/]+/i,
					inside: {
						'punctuation': /^<\/?/,
						'namespace': /^[^\s>\/:]+:/
					}
				},
				'attr-value': {
					pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
					inside: {
						'punctuation': [
							/^=/,
							{
								pattern: /(^|[^\\])["']/,
								lookbehind: true
							}
						]
					}
				},
				'punctuation': /\/?>/,
				'attr-name': {
					pattern: /[^\s>\/]+/,
					inside: {
						'namespace': /^[^\s>\/:]+:/
					}
				}
	
			}
		},
		'entity': /&#?[\da-z]{1,8};/i
	};
	
	Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
		Prism.languages.markup['entity'];
	
	// Plugin to make entity title show the real entity, idea by Roman Komarov
	Prism.hooks.add('wrap', function(env) {
	
		if (env.type === 'entity') {
			env.attributes['title'] = env.content.replace(/&amp;/, '&');
		}
	});
	
	Prism.languages.xml = Prism.languages.markup;
	Prism.languages.html = Prism.languages.markup;
	Prism.languages.mathml = Prism.languages.markup;
	Prism.languages.svg = Prism.languages.markup;
	
	
	/* **********************************************
	     Begin prism-css.js
	********************************************** */
	
	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: /@[\w-]+?.*?(?:;|(?=\s*\{))/i,
			inside: {
				'rule': /@[\w-]+/
				// See rest below
			}
		},
		'url': /url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
		'selector': /[^{}\s][^{};]*?(?=\s*\{)/,
		'string': {
			pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: true
		},
		'property': /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
		'important': /\B!important\b/i,
		'function': /[-a-z0-9]+(?=\()/i,
		'punctuation': /[(){};:]/
	};
	
	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
	
	if (Prism.languages.markup) {
		Prism.languages.insertBefore('markup', 'tag', {
			'style': {
				pattern: /(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,
				lookbehind: true,
				inside: Prism.languages.css,
				alias: 'language-css',
				greedy: true
			}
		});
	
		Prism.languages.insertBefore('inside', 'attr-value', {
			'style-attr': {
				pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
				inside: {
					'attr-name': {
						pattern: /^\s*style/i,
						inside: Prism.languages.markup.tag.inside
					},
					'punctuation': /^\s*=\s*['"]|['"]\s*$/,
					'attr-value': {
						pattern: /.+/i,
						inside: Prism.languages.css
					}
				},
				alias: 'language-css'
			}
		}, Prism.languages.markup.tag);
	}
	
	/* **********************************************
	     Begin prism-clike.js
	********************************************** */
	
	Prism.languages.clike = {
		'comment': [
			{
				pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
				lookbehind: true
			},
			{
				pattern: /(^|[^\\:])\/\/.*/,
				lookbehind: true,
				greedy: true
			}
		],
		'string': {
			pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: true
		},
		'class-name': {
			pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
			lookbehind: true,
			inside: {
				punctuation: /[.\\]/
			}
		},
		'keyword': /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
		'boolean': /\b(?:true|false)\b/,
		'function': /[a-z0-9_]+(?=\()/i,
		'number': /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
		'operator': /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
		'punctuation': /[{}[\];(),.:]/
	};
	
	
	/* **********************************************
	     Begin prism-javascript.js
	********************************************** */
	
	Prism.languages.javascript = Prism.languages.extend('clike', {
		'keyword': /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
		'number': /\b(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|NaN|Infinity)\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
		// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
		'function': /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*\()/i,
		'operator': /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
	});
	
	Prism.languages.insertBefore('javascript', 'keyword', {
		'regex': {
			pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[[^\]\r\n]+]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
			lookbehind: true,
			greedy: true
		},
		// This must be declared before keyword because we use "function" inside the look-forward
		'function-variable': {
			pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i,
			alias: 'function'
		},
		'constant': /\b[A-Z][A-Z\d_]*\b/
	});
	
	Prism.languages.insertBefore('javascript', 'string', {
		'template-string': {
			pattern: /`(?:\\[\s\S]|[^\\`])*`/,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /\$\{[^}]+\}/,
					inside: {
						'interpolation-punctuation': {
							pattern: /^\$\{|\}$/,
							alias: 'punctuation'
						},
						rest: Prism.languages.javascript
					}
				},
				'string': /[\s\S]+/
			}
		}
	});
	
	if (Prism.languages.markup) {
		Prism.languages.insertBefore('markup', 'tag', {
			'script': {
				pattern: /(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
				lookbehind: true,
				inside: Prism.languages.javascript,
				alias: 'language-javascript',
				greedy: true
			}
		});
	}
	
	Prism.languages.js = Prism.languages.javascript;
	
	
	/* **********************************************
	     Begin prism-file-highlight.js
	********************************************** */
	
	(function () {
		if (typeof self === 'undefined' || !self.Prism || !self.document || !document.querySelector) {
			return;
		}
	
		self.Prism.fileHighlight = function() {
	
			var Extensions = {
				'js': 'javascript',
				'py': 'python',
				'rb': 'ruby',
				'ps1': 'powershell',
				'psm1': 'powershell',
				'sh': 'bash',
				'bat': 'batch',
				'h': 'c',
				'tex': 'latex'
			};
	
			Array.prototype.slice.call(document.querySelectorAll('pre[data-src]')).forEach(function (pre) {
				var src = pre.getAttribute('data-src');
	
				var language, parent = pre;
				var lang = /\blang(?:uage)?-(?!\*)([\w-]+)\b/i;
				while (parent && !lang.test(parent.className)) {
					parent = parent.parentNode;
				}
	
				if (parent) {
					language = (pre.className.match(lang) || [, ''])[1];
				}
	
				if (!language) {
					var extension = (src.match(/\.(\w+)$/) || [, ''])[1];
					language = Extensions[extension] || extension;
				}
	
				var code = document.createElement('code');
				code.className = 'language-' + language;
	
				pre.textContent = '';
	
				code.textContent = 'Loading…';
	
				pre.appendChild(code);
	
				var xhr = new XMLHttpRequest();
	
				xhr.open('GET', src, true);
	
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
	
						if (xhr.status < 400 && xhr.responseText) {
							code.textContent = xhr.responseText;
	
							Prism.highlightElement(code);
						}
						else if (xhr.status >= 400) {
							code.textContent = '✖ Error ' + xhr.status + ' while fetching file: ' + xhr.statusText;
						}
						else {
							code.textContent = '✖ Error: File does not exist or is empty';
						}
					}
				};
	
				if (pre.hasAttribute('data-download-link') && Prism.plugins.toolbar) {
					Prism.plugins.toolbar.registerButton('download-file', function () {
						var a = document.createElement('a');
						a.textContent = pre.getAttribute('data-download-link-label') || 'Download';
						a.setAttribute('download', '');
						a.href = src;
						return a;
					});
				}
	
				xhr.send(null);
			});
	
		};
	
		document.addEventListener('DOMContentLoaded', self.Prism.fileHighlight);
	
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/prismjs/themes/prism.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	    var siteTitle = _ref.siteTitle;
	    return _react2.default.createElement(
	        "footer",
	        { className: "c-footer", role: "contentinfo" },
	        _react2.default.createElement(
	            "ul",
	            { className: "c-footer-nav" },
	            _react2.default.createElement(
	                "li",
	                { className: "c-footer-nav__item" },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-footer-nav__link", to: "/about" },
	                    "About"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                { className: "c-footer-nav__item" },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-footer-nav__link", to: "/roadmap" },
	                    "Roadmap"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                { className: "c-footer-nav__item" },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-footer-nav__link", to: "/history" },
	                    "Release History"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                { className: "c-footer-nav__item" },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-footer-nav__link", to: "/contribute" },
	                    "Contribute"
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Header.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Header = undefined;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Logo = __webpack_require__("./src/components/Logo.js");
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Button = __webpack_require__("./src/components/Button.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PrimaryNav = __webpack_require__("./src/components/PrimaryNav.js");
	
	var _PrimaryNav2 = _interopRequireDefault(_PrimaryNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = exports.Header = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = { isToggleOn: true };
	
	        _this.toggleMenu = _this.toggleMenu.bind(_this);
	        return _this;
	    }
	
	    Header.prototype.toggleMenu = function toggleMenu(e) {
	        this.setState(function (prevState) {
	            return {
	                isToggleOn: !prevState.isToggleOn
	            };
	        });
	    };
	
	    Header.prototype.render = function render() {
	        var headerClass = (0, _classnames2.default)({
	            "c-header": true,
	            "ads-u-margin-bottom-none": this.props.styleModifier === "ads-u-margin-bottom-none",
	            "c-header--vertical": this.props.styleModifier === "c-header--vertical"
	        });
	
	        return _react2.default.createElement(
	            "header",
	            { className: headerClass, status: "Complete", role: "banner" },
	            _react2.default.createElement(
	                "div",
	                { className: "c-header__inner" },
	                _react2.default.createElement(_Logo2.default, { siteTitle: this.props.siteTitle }),
	                _react2.default.createElement(_Button2.default, {
	                    styleModifier: "c-btn--small c-header__nav-btn",
	                    text: this.state.isToggleOn ? "Menu" : "Close",
	                    onClickHandler: this.toggleMenu
	                }),
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: this.state.isToggleOn ? "c-header__nav-container" : "c-header__nav-container is-active"
	                    },
	                    _react2.default.createElement(_PrimaryNav2.default, { data: this.props.navData, toggleStatus: this.toggleMenu })
	                )
	            )
	        );
	    };
	
	    return Header;
	}(_react.Component);
	
	exports.default = Header;

/***/ }),

/***/ "./src/components/Logo.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo(_ref) {
	    var siteTitle = _ref.siteTitle;
	    return _react2.default.createElement(
	        "h3",
	        { className: "c-logo" },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: "c-logo__link", to: "/" },
	            _react2.default.createElement(
	                "svg",
	                { className: "c-logo__img", width: "644px", height: "53px", viewBox: "0 0 644 53", version: "1.1" },
	                _react2.default.createElement(
	                    "title",
	                    null,
	                    "Style Guide Guide"
	                ),
	                _react2.default.createElement("path", { d: "M20.86,52.36 C18.8533233,52.36 16.8816764,52.1850017 14.945,51.835 C13.0083236,51.4849983 11.1416756,50.97167 9.345,50.295 C7.54832435,49.6183299 5.8566746,48.8250046 4.27,47.915 C2.6833254,47.0049955 1.2600063,45.9900056 0,44.87 L10.15,33.81 C11.3166725,35.0700063 12.8683236,36.1899951 14.805,37.17 C16.7416763,38.1500049 18.7366564,38.64 20.79,38.64 C21.723338,38.64 22.5749962,38.4766683 23.345,38.15 C24.1150039,37.8233317 24.5,37.2166711 24.5,36.33 C24.5,35.863331 24.3716679,35.4666683 24.115,35.14 C23.858332,34.8133317 23.4033366,34.4750018 22.75,34.125 C22.0966634,33.7749983 21.198339,33.3900021 20.055,32.97 C18.911661,32.5499979 17.4766753,32.0600028 15.75,31.5 C14.0699916,30.9399972 12.4600077,30.2750039 10.92,29.505 C9.3799923,28.7349962 8.01500595,27.7900056 6.825,26.67 C5.63499405,25.5499944 4.6900035,24.2083412 3.99,22.645 C3.2899965,21.0816589 2.94,19.2033443 2.94,17.01 C2.94,13.9299846 3.5699937,11.3166774 4.83,9.17 C6.0900063,7.0233226 7.71165675,5.26167355 9.695,3.885 C11.6783432,2.50832645 13.9066543,1.5166697 16.38,0.91 C18.8533457,0.3033303 21.3033212,0 23.73,0 C26.996683,0 30.3216498,0.6299937 33.705,1.89 C37.0883502,3.1500063 40.0633205,4.9699881 42.63,7.35 L32.27,17.92 C31.1499944,16.519993 29.7733415,15.4583369 28.14,14.735 C26.5066585,14.0116631 25.0366732,13.65 23.73,13.65 C22.5166606,13.65 21.5366704,13.8249983 20.79,14.175 C20.0433296,14.5250017 19.67,15.0966627 19.67,15.89 C19.67,16.6366704 20.0549961,17.1966648 20.825,17.57 C21.5950038,17.9433352 22.8433247,18.4099972 24.57,18.97 C26.3433422,19.5300028 28.2099902,20.1833296 30.17,20.93 C32.1300098,21.6766704 33.938325,22.644994 35.595,23.835 C37.251675,25.025006 38.6166613,26.4833247 39.69,28.21 C40.7633387,29.9366753 41.3,32.0833205 41.3,34.65 C41.3,37.6366816 40.7050059,40.2383223 39.515,42.455 C38.324994,44.6716778 36.7616763,46.5149927 34.825,47.985 C32.8883236,49.4550074 30.7066788,50.551663 28.28,51.275 C25.8533212,51.998337 23.3800126,52.36 20.86,52.36 Z M69.38,50.96 L52.72,50.96 L52.72,15.47 L40.54,15.47 L40.54,1.4 L81.56,1.4 L81.56,15.47 L69.38,15.47 L69.38,50.96 Z M112.58,50.96 L95.9200001,50.96 L95.9200001,30.66 L77.2300001,1.4 L97.3200001,1.4 L105.16,15.96 L112.65,1.4 L132.25,1.4 L112.58,30.66 L112.58,50.96 Z M132.89,1.4 L149.69,1.4 L149.69,36.68 L166.14,36.68 L166.14,50.96 L132.89,50.96 L132.89,1.4 Z M169.02,1.4 L203.11,1.4 L203.11,15.26 L184.7,15.26 L184.7,19.53 L201.99,19.53 L201.99,32.48 L184.7,32.48 L184.7,37.1 L204.3,37.1 L204.3,50.96 L169.02,50.96 L169.02,1.4 Z M234.13,52.22 C230.209981,52.22 226.581684,51.6133394 223.245,50.4 C219.908317,49.1866606 217.015012,47.4483447 214.565,45.185 C212.114988,42.9216554 210.190007,40.1800161 208.79,36.96 C207.389993,33.7399839 206.69,30.1466865 206.69,26.18 C206.69,22.2133135 207.389993,18.6200161 208.79,15.4 C210.190007,12.1799839 212.103321,9.4266781 214.53,7.14 C216.956679,4.8533219 219.803317,3.09167285 223.07,1.855 C226.336683,0.61832715 229.836648,0 233.57,0 C237.443353,0 241.118316,0.6299937 244.595,1.89 C248.071684,3.1500063 250.906656,4.8766557 253.1,7.07 L243.37,18.76 C242.343328,17.5466606 241.130007,16.578337 239.73,15.855 C238.329993,15.1316631 236.603344,14.77 234.55,14.77 C233.19666,14.77 231.87834,15.0383307 230.595,15.575 C229.31166,16.1116694 228.180005,16.8816617 227.2,17.885 C226.219995,18.8883384 225.42667,20.089993 224.82,21.49 C224.213331,22.890007 223.91,24.4533247 223.91,26.18 C223.91,29.6333506 224.808325,32.4449892 226.605,34.615 C228.401676,36.7850109 231.283314,37.87 235.25,37.87 C235.950004,37.87 236.67333,37.8116673 237.42,37.695 C238.166671,37.5783328 238.749998,37.4033345 239.17,37.17 L239.17,33.39 L231.19,33.39 L231.19,20.3 L253.94,20.3 L253.94,47.39 C252.773328,48.0900035 251.431674,48.7316638 249.915,49.315 C248.398326,49.8983363 246.788342,50.3999979 245.085,50.82 C243.381658,51.2400021 241.596676,51.5783321 239.73,51.835 C237.863324,52.091668 235.996676,52.22 234.13,52.22 Z M282.23,52.36 C278.356648,52.36 274.985015,51.8233387 272.115,50.75 C269.244986,49.6766613 266.853343,48.206676 264.94,46.34 C263.026657,44.473324 261.603338,42.2683461 260.67,39.725 C259.736662,37.181654 259.27,34.4400147 259.27,31.5 L259.27,1.4 L275.93,1.4 L275.93,29.68 C275.93,32.0600119 276.501661,33.9149934 277.645,35.245 C278.788339,36.5750067 280.40999,37.24 282.51,37.24 C284.610011,37.24 286.231661,36.5750067 287.375,35.245 C288.518339,33.9149934 289.09,32.0600119 289.09,29.68 L289.09,1.4 L305.68,1.4 L305.68,31.5 C305.68,34.4400147 305.178339,37.181654 304.175,39.725 C303.171662,42.2683461 301.69001,44.473324 299.73,46.34 C297.76999,48.206676 295.331682,49.6766613 292.415,50.75 C289.498319,51.8233387 286.103353,52.36 282.23,52.36 Z M311.92,1.4 L328.72,1.4 L328.72,50.96 L311.92,50.96 L311.92,1.4 Z M335.66,50.96 L335.66,1.4 L354.14,1.4 C358.06002,1.4 361.804983,1.78499615 365.375,2.555 C368.945018,3.32500385 372.094987,4.65499055 374.825,6.545 C377.555014,8.43500945 379.736659,10.9433177 381.37,14.07 C383.003342,17.1966823 383.82,21.1399762 383.82,25.9 C383.82,30.2400217 383.038342,33.9966508 381.475,37.17 C379.911659,40.3433492 377.823347,42.9449899 375.21,44.975 C372.596654,47.0050102 369.586684,48.5099951 366.18,49.49 C362.773317,50.4700049 359.226685,50.96 355.54,50.96 L335.66,50.96 Z M351.69,15.54 L351.69,36.68 L354.77,36.68 C358.69002,36.68 361.69999,35.8283419 363.8,34.125 C365.900011,32.4216582 366.95,29.6333527 366.95,25.76 C366.95,22.5399839 365.900011,20.0316757 363.8,18.235 C361.69999,16.4383244 358.900018,15.54 355.4,15.54 L351.69,15.54 Z M388.52,1.4 L422.61,1.4 L422.61,15.26 L404.2,15.26 L404.2,19.53 L421.49,19.53 L421.49,32.48 L404.2,32.48 L404.2,37.1 L423.8,37.1 L423.8,50.96 L388.52,50.96 L388.52,1.4 Z M453.63,52.22 C449.709981,52.22 446.081684,51.6133394 442.745,50.4 C439.408317,49.1866606 436.515013,47.4483447 434.065,45.185 C431.614988,42.9216554 429.690007,40.1800161 428.29,36.96 C426.889993,33.7399839 426.19,30.1466865 426.19,26.18 C426.19,22.2133135 426.889993,18.6200161 428.29,15.4 C429.690007,12.1799839 431.603322,9.4266781 434.03,7.14 C436.456679,4.8533219 439.303317,3.09167285 442.57,1.855 C445.836683,0.61832715 449.336648,0 453.07,0 C456.943353,0 460.618316,0.6299937 464.095,1.89 C467.571685,3.1500063 470.406656,4.8766557 472.6,7.07 L462.87,18.76 C461.843329,17.5466606 460.630007,16.578337 459.23,15.855 C457.829993,15.1316631 456.103344,14.77 454.05,14.77 C452.69666,14.77 451.37834,15.0383307 450.095,15.575 C448.811661,16.1116694 447.680005,16.8816617 446.7,17.885 C445.719996,18.8883384 444.92667,20.089993 444.32,21.49 C443.713331,22.890007 443.41,24.4533247 443.41,26.18 C443.41,29.6333506 444.308325,32.4449892 446.105,34.615 C447.901676,36.7850109 450.783314,37.87 454.75,37.87 C455.450004,37.87 456.17333,37.8116673 456.92,37.695 C457.666671,37.5783328 458.249998,37.4033345 458.67,37.17 L458.67,33.39 L450.69,33.39 L450.69,20.3 L473.44,20.3 L473.44,47.39 C472.273328,48.0900035 470.931675,48.7316638 469.415,49.315 C467.898326,49.8983363 466.288342,50.3999979 464.585,50.82 C462.881659,51.2400021 461.096676,51.5783321 459.23,51.835 C457.363324,52.091668 455.496676,52.22 453.63,52.22 Z M501.730001,52.36 C497.856648,52.36 494.485015,51.8233387 491.615001,50.75 C488.744986,49.6766613 486.353343,48.206676 484.440001,46.34 C482.526658,44.473324 481.103339,42.2683461 480.170001,39.725 C479.236663,37.181654 478.770001,34.4400147 478.770001,31.5 L478.770001,1.4 L495.430001,1.4 L495.430001,29.68 C495.430001,32.0600119 496.001661,33.9149934 497.145001,35.245 C498.28834,36.5750067 499.90999,37.24 502.010001,37.24 C504.110011,37.24 505.731661,36.5750067 506.875001,35.245 C508.01834,33.9149934 508.590001,32.0600119 508.590001,29.68 L508.590001,1.4 L525.180001,1.4 L525.180001,31.5 C525.180001,34.4400147 524.678339,37.181654 523.675001,39.725 C522.671662,42.2683461 521.19001,44.473324 519.230001,46.34 C517.269991,48.206676 514.831682,49.6766613 511.915001,50.75 C508.998319,51.8233387 505.603353,52.36 501.730001,52.36 Z M531.420001,1.4 L548.220001,1.4 L548.220001,50.96 L531.420001,50.96 L531.420001,1.4 Z M555.160001,50.96 L555.160001,1.4 L573.640001,1.4 C577.56002,1.4 581.304983,1.78499615 584.875001,2.555 C588.445018,3.32500385 591.594987,4.65499055 594.325001,6.545 C597.055014,8.43500945 599.236659,10.9433177 600.870001,14.07 C602.503342,17.1966823 603.320001,21.1399762 603.320001,25.9 C603.320001,30.2400217 602.538342,33.9966508 600.975001,37.17 C599.411659,40.3433492 597.323347,42.9449899 594.710001,44.975 C592.096654,47.0050102 589.086684,48.5099951 585.680001,49.49 C582.273317,50.4700049 578.726686,50.96 575.040001,50.96 L555.160001,50.96 Z M571.190001,15.54 L571.190001,36.68 L574.270001,36.68 C578.19002,36.68 581.19999,35.8283419 583.300001,34.125 C585.400011,32.4216582 586.450001,29.6333527 586.450001,25.76 C586.450001,22.5399839 585.400011,20.0316757 583.300001,18.235 C581.19999,16.4383244 578.400018,15.54 574.900001,15.54 L571.190001,15.54 Z M608.020001,1.4 L642.110001,1.4 L642.110001,15.26 L623.700001,15.26 L623.700001,19.53 L640.990001,19.53 L640.990001,32.48 L623.700001,32.48 L623.700001,37.1 L643.300001,37.1 L643.300001,50.96 L608.020001,50.96 L608.020001,1.4 Z", id: "STYLEGUIDEGUIDE", fill: "#565656" })
	            )
	        )
	    );
	};
	
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/PrimaryNav.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PrimaryNavItem = __webpack_require__("./src/components/PrimaryNavItem.js");
	
	var _PrimaryNavItem2 = _interopRequireDefault(_PrimaryNavItem);
	
	var _PrimarySubNavItem = __webpack_require__("./src/components/PrimarySubNavItem.js");
	
	var _PrimarySubNavItem2 = _interopRequireDefault(_PrimarySubNavItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimaryNav = function PrimaryNav(_ref) {
	    var data = _ref.data,
	        toggleStatus = _ref.toggleStatus;
	    return _react2.default.createElement(
	        "nav",
	        { className: "c-primary-nav", role: "navigation" },
	        _react2.default.createElement(
	            "ul",
	            { className: "c-primary-nav__list", role: "tablist", "aria-multiselectable": "true" },
	            _react2.default.createElement(_PrimaryNavItem2.default, { href: "/getting-started", label: "Getting Started", toggleStatus: toggleStatus }),
	            _react2.default.createElement(_PrimaryNavItem2.default, {
	                href: "/guidelines",
	                label: "Guidelines",
	                toggleStatus: toggleStatus,
	                subNavItem: _react2.default.createElement(
	                    "ul",
	                    { className: "c-primary-nav__sublist" },
	                    data.filter(function (post) {
	                        return post.node.frontmatter.group == 'guidelines';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.layout == 'landing';
	                    }).map(function (_ref2) {
	                        var post = _ref2.node;
	
	                        return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                    }),
	                    data.filter(function (post) {
	                        return post.node.frontmatter.group == 'guidelines';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.layout == 'page';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.status == 'Complete';
	                    }).map(function (_ref3) {
	                        var post = _ref3.node;
	
	                        return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                    })
	                )
	            }),
	            _react2.default.createElement(_PrimaryNavItem2.default, {
	                href: "/styles",
	                label: "Styles",
	                toggleStatus: toggleStatus,
	                subNavItem: _react2.default.createElement(
	                    "ul",
	                    { className: "c-primary-nav__sublist" },
	                    data.filter(function (post) {
	                        return post.node.frontmatter.group == 'styles';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.layout == 'landing';
	                    }).map(function (_ref4) {
	                        var post = _ref4.node;
	
	                        return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                    }),
	                    data.filter(function (post) {
	                        return post.node.frontmatter.group == 'styles';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.layout == 'page';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.status == 'Complete';
	                    }).map(function (_ref5) {
	                        var post = _ref5.node;
	
	                        return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                    })
	                )
	            }),
	            _react2.default.createElement(_PrimaryNavItem2.default, {
	                href: "/components",
	                label: "Components",
	                toggleStatus: toggleStatus,
	                subNavItem: _react2.default.createElement(
	                    "ul",
	                    { className: "c-primary-nav__sublist" },
	                    _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: "/components", toggleStatus: toggleStatus }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Blocks and cards",
	                        url: "/components/blocks-and-cards",
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'blocks-and-cards';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref6) {
	                                var post = _ref6.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'blocks-and-cards';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref7) {
	                                var post = _ref7.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Buttons",
	                        url: "/components/buttons",
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'buttons';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref8) {
	                                var post = _ref8.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'buttons';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref9) {
	                                var post = _ref9.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Charts and graphs",
	                        url: "/components/charts-and-graphs",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'charts-and-graphs';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref10) {
	                                var post = _ref10.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'charts-and-graphs';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref11) {
	                                var post = _ref11.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Form controls",
	                        url: "/components/form-controls",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'form-controls';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref12) {
	                                var post = _ref12.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'form-controls';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref13) {
	                                var post = _ref13.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Headers and footers",
	                        url: "/components/headers-and-footers",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'headers-and-footers';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref14) {
	                                var post = _ref14.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'headers-and-footers';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref15) {
	                                var post = _ref15.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Icons",
	                        url: "/components/icons",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'icons';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref16) {
	                                var post = _ref16.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'icons';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref17) {
	                                var post = _ref17.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Interactive",
	                        url: "/components/interactive",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'interactive';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref18) {
	                                var post = _ref18.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'interactive';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref19) {
	                                var post = _ref19.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Lists and collections",
	                        url: "/components/lists-and-collections",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'lists-and-collections';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref20) {
	                                var post = _ref20.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'lists-and-collections';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref21) {
	                                var post = _ref21.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Media",
	                        url: "/components/media",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'media';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref22) {
	                                var post = _ref22.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'media';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref23) {
	                                var post = _ref23.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Messaging",
	                        url: "/components/messaging",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'messaging';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref24) {
	                                var post = _ref24.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'messaging';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref25) {
	                                var post = _ref25.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Navigation",
	                        url: "/components/navigation",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'navigation';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref26) {
	                                var post = _ref26.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'navigation';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref27) {
	                                var post = _ref27.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Tables",
	                        url: "/components/tables",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'tables';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref28) {
	                                var post = _ref28.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'tables';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref29) {
	                                var post = _ref29.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    }),
	                    _react2.default.createElement(_PrimarySubNavItem2.default, {
	                        title: "Text",
	                        url: "/components/text",
	                        toggleStatus: toggleStatus,
	                        subSubNavItems: _react2.default.createElement(
	                            "ul",
	                            { className: "c-primary-nav__sublist" },
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'text';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-category';
	                            }).map(function (_ref30) {
	                                var post = _ref30.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            }),
	                            data.filter(function (post) {
	                                return post.node.frontmatter.group == 'components';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.subgroup == 'text';
	                            }).filter(function (post) {
	                                return post.node.frontmatter.layout == 'component-detail';
	                            }).map(function (_ref31) {
	                                var post = _ref31.node;
	
	                                return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                            })
	                        )
	                    })
	                )
	            }),
	            _react2.default.createElement(_PrimaryNavItem2.default, {
	                href: "/utilities",
	                label: "Utilities",
	                toggleStatus: toggleStatus,
	                subNavItem: _react2.default.createElement(
	                    "ul",
	                    { className: "c-primary-nav__sublist" },
	                    data.filter(function (post) {
	                        return post.node.frontmatter.group == 'utilities';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.layout == 'utilities-index';
	                    }).map(function (_ref32) {
	                        var post = _ref32.node;
	
	                        return _react2.default.createElement(_PrimarySubNavItem2.default, { title: "Overview", url: post.frontmatter.path, toggleStatus: toggleStatus });
	                    }),
	                    data.filter(function (post) {
	                        return post.node.frontmatter.group == 'utilities';
	                    }).filter(function (post) {
	                        return post.node.frontmatter.layout == 'component-detail';
	                    }).map(function (_ref33) {
	                        var post = _ref33.node;
	
	                        return _react2.default.createElement(_PrimarySubNavItem2.default, { title: post.frontmatter.title, url: post.frontmatter.path, toggleStatus: toggleStatus });
	                    })
	                )
	            }),
	            _react2.default.createElement(_PrimaryNavItem2.default, {
	                href: "/page-templates",
	                label: "Page Templates",
	                toggleStatus: toggleStatus
	            }),
	            _react2.default.createElement(_PrimaryNavItem2.default, { href: "/downloads", label: "Downloads", toggleStatus: toggleStatus }),
	            _react2.default.createElement(_PrimaryNavItem2.default, { href: "/support", label: "Support", toggleStatus: toggleStatus }),
	            _react2.default.createElement(_PrimaryNavItem2.default, { href: "/contribute", label: "Contribute", toggleStatus: toggleStatus })
	        )
	    );
	};
	
	exports.default = PrimaryNav;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/PrimaryNavItem.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PrimaryNavItem = undefined;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimaryNavItem = exports.PrimaryNavItem = function (_Component) {
	    _inherits(PrimaryNavItem, _Component);
	
	    function PrimaryNavItem(props) {
	        _classCallCheck(this, PrimaryNavItem);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = { isNavOn: true };
	        _this.toggleNav = _this.toggleNav.bind(_this);
	        return _this;
	    }
	
	    PrimaryNavItem.prototype.toggleNav = function toggleNav(e) {
	        if (this.props.subNavItem) {
	            e.preventDefault();
	            this.setState(function (prevState) {
	                return {
	                    isNavOn: !prevState.isNavOn
	                };
	            });
	        } else if (document.querySelector(".c-header__nav-container.is-active")) {
	            this.props.toggleStatus(e);
	        } else {
	            null;
	        }
	    };
	
	    PrimaryNavItem.prototype.render = function render() {
	        return _react2.default.createElement(
	            "li",
	            { className: this.state.isNavOn ? "c-primary-nav__item " : "c-primary-nav__item is-active", key: this.props.index },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: this.props.subNavItem ? "c-primary-nav__link  c-primary-nav__link--has-children" : "c-primary-nav__link", to: this.props.href, onClick: this.toggleNav },
	                _react2.default.createElement(
	                    "span",
	                    { className: "c-primary-nav__text" },
	                    this.props.label
	                ),
	                this.props.subNavItem && _react2.default.createElement(
	                    "svg",
	                    { className: "c-icon c-primary-nav__icon", width: "16", height: "16", viewBox: "0 0 7 16", id: "chevron-right" },
	                    _react2.default.createElement(
	                        "title",
	                        null,
	                        "chevron-right"
	                    ),
	                    _react2.default.createElement("path", { d: "M2 3L0 5l3 3-3 3 2 2 5-5-5-5z" })
	                )
	            ),
	            this.props.subNavItem && this.props.subNavItem
	        );
	    };
	
	    return PrimaryNavItem;
	}(_react.Component);
	
	;
	
	exports.default = PrimaryNavItem;

/***/ }),

/***/ "./src/components/PrimarySubNavItem.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PrimarySubNavItem = undefined;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimarySubNavItem = exports.PrimarySubNavItem = function (_Component) {
	    _inherits(PrimarySubNavItem, _Component);
	
	    function PrimarySubNavItem(props) {
	        _classCallCheck(this, PrimarySubNavItem);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = { isSubNavOn: true };
	        _this.toggleSubNav = _this.toggleSubNav.bind(_this);
	        return _this;
	    }
	
	    PrimarySubNavItem.prototype.toggleSubNav = function toggleSubNav(e) {
	        if (this.props.subSubNavItems) {
	            e.preventDefault();
	            this.setState(function (prevState) {
	                return {
	                    isSubNavOn: !prevState.isSubNavOn
	                };
	            });
	        } else if (document.querySelector(".c-header__nav-container.is-active")) {
	            this.props.toggleStatus(e);
	        } else {
	            null;
	        }
	    };
	
	    PrimarySubNavItem.prototype.render = function render() {
	        return _react2.default.createElement(
	            "li",
	            { className: this.state.isSubNavOn ? "c-primary-nav__subitem " : "c-primary-nav__subitem is-active", key: this.props.url },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "c-primary-nav__sublink", to: this.props.url, onClick: this.toggleSubNav },
	                _react2.default.createElement(
	                    "span",
	                    { className: "c-primary-nav__text" },
	                    this.props.title
	                ),
	                this.props.subSubNavItems && _react2.default.createElement(
	                    "svg",
	                    { className: "c-icon c-primary-nav__subicon", width: "16", height: "16", viewBox: "0 0 7 16", id: "chevron-right" },
	                    _react2.default.createElement(
	                        "title",
	                        null,
	                        "chevron-right"
	                    ),
	                    _react2.default.createElement("path", { d: "M2 3L0 5l3 3-3 3 2 2 5-5-5-5z" })
	                )
	            ),
	            this.props.subSubNavItems && this.props.subSubNavItems
	        );
	    };
	
	    return PrimarySubNavItem;
	}(_react.Component);
	
	;
	
	exports.default = PrimarySubNavItem;

/***/ }),

/***/ "./src/css/style-guide.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/css/style.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.layoutQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__("./src/components/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__("./src/components/Footer.js");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__("./src/css/style.css");
	
	__webpack_require__("./src/css/style-guide.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__("./node_modules/prismjs/prism.js");
	__webpack_require__("./node_modules/prismjs/themes/prism.css");
	
	exports.default = function (_ref) {
		var children = _ref.children,
		    data = _ref.data;
	
		if (typeof window !== 'undefined') {
			if (document.readyState !== "loading") {
				setTimeout(Prism.highlightAll, 0);
			} else {
				document.addEventListener('DOMContentLoaded', Prism.highlightAll);
			}
		}
		var posts = data.allMarkdownRemark.edges;
	
		return _react2.default.createElement(
			"div",
			{ className: "c-wrapper" },
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					"title",
					null,
					"Style Guide Guide"
				),
				_react2.default.createElement("meta", { charSet: "utf-8" }),
				_react2.default.createElement("meta", { name: "description", content: "A boilerplate for creating superb style guides" }),
				_react2.default.createElement("meta", { name: "keywords", content: "style guide guide" }),
				_react2.default.createElement("link", { rel: "icon", href: "./favicon.ico" }),
				_react2.default.createElement("link", { rel: "stylesheet", href: "https://use.typekit.net/agm6qos.css" })
			),
			_react2.default.createElement(
				"div",
				{ className: "l-page-layout l-page-layout--two-column-fixed" },
				_react2.default.createElement(
					"div",
					{ className: "l-page-layout__secondary" },
					_react2.default.createElement(_Header2.default, { siteTitle: "Style Guide Guide", styleModifier: "c-header--vertical", navData: posts })
				),
				_react2.default.createElement(
					"div",
					{ className: "l-page-layout__main" },
					_react2.default.createElement(
						"main",
						{ role: "main" },
						children()
					),
					_react2.default.createElement(_Footer2.default, null)
				)
			)
		);
	};
	
	var layoutQuery = exports.layoutQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-ee4935d47ceade2941e1.js